/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {HTTPValidationError, ProfilerMode} from '../models/index';
import {
  HTTPValidationErrorFromJSON,
  HTTPValidationErrorToJSON,
  ProfilerModeFromJSON,
  ProfilerModeToJSON
} from '../models/index';

export interface OidcGetJwtInfoRequest {
  xProfilerMode?: ProfilerMode;
  xSessionId?: string | null;
}

/**
 *
 */
export class OidcApi extends runtime.BaseAPI {
  /**
   * Get Jwt Info
   */
  async oidcGetJwtInfoRaw(
    requestParameters: OidcGetJwtInfoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<object>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters['xProfilerMode'] != null) {
      headerParameters['X-Profiler-Mode'] = String(requestParameters['xProfilerMode']);
    }

    if (requestParameters['xSessionId'] != null) {
      headerParameters['X-Session-Id'] = String(requestParameters['xSessionId']);
    }

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters['Authorization'] = await this.configuration.accessToken('OpenIdConnect', []);
    }

    const response = await this.request(
      {
        path: `/api/public/v1/oidc/check`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Get Jwt Info
   */
  async oidcGetJwtInfo(
    requestParameters: OidcGetJwtInfoRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<object> {
    const response = await this.oidcGetJwtInfoRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
